import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import FlagGroup from "shared/components/Country/FlagGroup"

import gridStyles from "../../../components/Plans.module.css"

const cx = classNames.bind(gridStyles)

const bodyClass = cx("row", "planCell")

const EBAY = "ebay"

const SITES = [
  "UK",
  "DE",
  "AT",
  "AU",
  "BE",
  "CA",
  "ES",
  "FR",
  "IE",
  "IT",
  "SG",
  "HK",
  "US",
]

const Internationalization = ({ plans }) => {
  const { t: translate } = useTranslate()

  return (
    <>
      <div className={cx(bodyClass, "mobileHeading", "featureDescriptionCell")}>
        <p className={gridStyles.sectionTitle}>
          {translate("Internationalization")}
        </p>
        <p className="w500 fs-16 m-b-0">
          {translate("Reach more buyers internationally")}
        </p>
        <span className={gridStyles.sectionHelperText}>
          {translate(
            "Your listings localized, compliant and published across multiple international marketplaces"
          )}
        </span>
      </div>
      {plans.map(plan => {
        const sites =
          plan?.services_available?.find(el => el.name === EBAY)
            ?.sites_available || SITES
        return (
          <div
            key={`INTERNATIONALIZATION_${plan.name}`}
            className={cx(
              bodyClass,
              "flex-container",
              "f-j-center",
              "f-a-center"
            )}
          >
            <FlagGroup
              countries={[...new Set(sites)]}
              size={30}
              className={gridStyles.flags}
            />
          </div>
        )
      })}
    </>
  )
}

Internationalization.propTypes = { plans: PropTypes.array }
Internationalization.defaultProps = { plans: [] }

export default Internationalization
